<template>
  <div class="row">
    <div class="col-sm-9">
      <div class="step-detail step-one">
        <h1 class="line-bottom">{{ $t('1. Selecteer welke producten u wil configureren')}}</h1>
        <div class="row">
          <div ref="leftFilter" :style="{ height: $parent.getStepDetailHeight($refs.leftFilter) }" class="col-lg-4 filters-wrapper">
<!--            <div class="filters-info line-bottom">
              <div class="filters-title">
                <span class="mdi mdi-filter-outline"></span>
                <h2>Filters</h2>
              </div>

              <div class="filter-actions">
                <button class="reset" @click="resetFilters" v-show="activeFilters.length > 0">
                  <span>Wis filters</span>
                  <span class="mdi mdi-window-close"></span>
                </button>
                <button class="show-all" @click="showModal = true">
                  <span>Toon alle filters</span>
                  <span class="mdi mdi-arrow-expand"></span>
                </button>
              </div>
            </div>-->

            <div class="line-bottom">
              <div class="search-with-filter-reset">
                <div class="e-search">
                  <input type="text" id="query" v-model="searchQuery" @keyup.enter="getProductByName" autocomplete="off" />
                  <button type="submit" class="icon" @click="getProductByName">
                    <span class="mdi mdi-magnify"></span>
                  </button>
                </div>
                <button class="reset" @click="resetFilters" v-show="activeFilters.length > 0">
                  <span class="mdi mdi-delete mdi-18px"></span>
                </button>
               <!-- <span class="mdi mdi-alert-circle mdi-18px"></span>-->
              </div>
              <!--<template v-for="filterValue in currentFilterValues" v-if="currentFilterValues.length">-->
                <!--{{filterValue}}-->
              <!--</template>-->
            </div>

            <filters :filterz="filters" :active-filters="activeFilters" class="scrollable"></filters>

<!--            <div class="filters-info">
              <div class="filter-actions">
                <button class="show-all" @click="showModal = true">
                  <span>Toon alle filters</span>
                  <span class="mdi mdi-arrow-expand"></span>
                </button>
              </div>
            </div>-->
          </div>
          <div class="detail col-lg-8">
<!--            <div class="active-filters line-bottom">
              <div class="info">
                <p>

                </p>
              </div>
              <div class="filters">
                <span>
                  Active filters
                  <span class="custom-tooltip mdi-18px mdi mdi-information-outline">
                    <span><span>
                      Verfijn de lijst van producten met de filters aan de linkerkant. Om geavanceerd te filteren (drukverschil, El,
                      minimale afstand, luchttechnische gegevens…) klik op “Toon allle filters )” . <br />
                      <strong>Na de configuratie van dit product kan u deze ook toepassen op andere producten.</strong>
                    </span></span>
                  </span>
                  :

                </span>
                <div class="tags" v-model="x">
                  <span v-for="(value, key) in filters['shape']" v-show="value">{{key}}</span>
                  <span v-if="this.filters.hasOwnProperty('width')">width: {{filters['width']['value']}}mm</span>
                  <span v-if="this.filters.hasOwnProperty('height')">height: {{filters['height']['value']}}mm</span>
                  <span v-if="this.filters.hasOwnProperty('diameter')">diameter: {{filters['diameter']['value']}}mm</span>
                </div>
              </div>
            </div>-->
            <div class="overview-products scrollable" ref="overviewProducts" :style="{ height: $parent.getStepDetailHeight($refs.overviewProducts) }">
              <template v-if="processedProducts.length === 0 && !searching">
                <p>{{ $t('Geen zoekresultaten gevonden voor de gekozen filter of zoekwoord')}}</p>
              </template>
              <template >

              </template>
              <template v-if="searching">
                <p>{{searchMessage}}</p>
              </template>
              <template v-for="(product, key) in processedProducts" v-if="!searching">
                <!--{{product.recommended}}-->
                <product-overview-item v-if="product.articles.length" :img-src="product.image"
                                       :key="key"
                                       :product-id="product.id"
                                       :title="product.title"
                                       :description="product.description"
                                       :recommended="product.recommended"
                                       :linkToWebsite="product.linkToWebsite"
                                       :articles="product.articles"
                                       :erpCode="product.erpCode">

                  <template slot="image">
                    <img :src="product.image" />
                  </template>

                  <template slot="text">
                    <ul>
                      <li v-for="specification in product.specifications">{{specification}}</li>
                    </ul>
                  </template>
                </product-overview-item>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-3" ref="yourSelectionWrapper" :style="{ height: $parent.getStepDetailHeight($refs.yourSelectionWrapper, false) }">
      <div class="your-selection col-sm-12">
        <div class="block title">
          <p>{{ $t('Uw selectie')}}</p>
        </div>

        <div class="block d-flex">
          <p v-if="warning !== ''">{{warning}}</p>
          <div class="prices">
            <div v-if="selected.sku !== ''" class="line">
              <div>{{selected.sku}}</div>
              <div>&euro; {{selected.price}}</div>
            </div>
          </div>
          <a v-if="selected.sku !== ''" @click="deleteEverything" class="reset" >
            <span class="mdi mdi-delete mdi-18px"></span>
          </a>
        </div>
        <div class="block">
          <p class="font-weight-normal">{{ $t('prijs_informatie')}}</p>
          <p class="font-weight-normal">{{ $t('prijs_informatie2')}}</p>
        </div>
        <button class="btn primary icon check" v-if="selected.name === ''" @click="nextStep(false)">
          {{ $t('OK, kies Mechanismes')}}
        </button>
        <router-link  :to="newMec" v-if="selected.name !== ''" @click="nextStep(true)">
          <button class="btn primary icon check">
            {{ $t('OK, kies Mechanismes')}}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductOverviewItem from '../components/elements/ProductOverviewItem';
  import Filters from '../components/elements/Filters';
  import apiService from '../services/request';
  import {EventBus} from '../services/eventBus';
  import Vue from 'vue'
  import translations from "../lang/translations"
  import { processLanguageParameter } from '../helpers'

  export default {
    name: 'StepOne',
    components: {
      'product-overview-item': ProductOverviewItem,
      'Filters': Filters
    },
    data() {
      return {
        filtersToHide: '',
        reset: '',
        showModal: false,
        page: 2,
        products: [],
        activeFilters: [],
        searchQuery: '',
        filterIndex: [],
        filters: {},
        currentFilterValues:[],
        newMec: '/steptwo',
        // allFilters: {},
        allFiltersModal: [],
        x: 1,
        searching: false,
        searchMessage: "Even geduld... uw zoekopdracht wordt verwerkt",
        selected: {sku: '', id: 0, mecs: '', price: '', image: '', erpCode: ''},
        warning: '',
        deleteVariantArr: [],
        searchViaProductId: false,
        languages: []
      };
    },
    methods: {
      resetFilters(e) {
        this.searchQuery = "";
        this.products = [];
        this.activeFilters = [];
        this.filterIndex = [];
        this.filters = [];
        Vue.ls.remove('shapeBefore')
        Vue.ls.remove('variantsIds')
        this.getFilters()
        this.getAllProducts()
        EventBus.$emit('filtersReset');
        //location.reload();

      },
      getAllProducts() {
        this.searching = true;
        this.searchMessage = this.$t('Even geduld... zoeken naar producten');
        apiService.getAllproducts('nl-be', this.setProducts)
      },
      getProductsById(id) {
        this.searching = true;
        this.searchMessage = this.$t('Even geduld... zoeken naar producten');
        apiService.getProductsById(id, 'nl-be', this.setProducts)
      },
      getFilters() {
        apiService.getFilters('', 'nl-be', this.setFilters)
      },
      setFilters(response) {
        this.filters = Object.assign({}, this.filters, response);
      },
      postFilters(filter) {
          Vue.ls.remove('variantsIds')
          this.searching = true;
          this.searchMessage = this.$t('Even geduld... uw filters worden verwerkt');
          this.searchQuery = "";
          EventBus.$emit('newPostFilter');
          let productsIds = Vue.ls.get('variantsIds')
          let reset = ''
          let shapeValue = ''
          let wandtypeValue = ''
          let deleteArr = []
          //*****************Special case shapes

          if (filter.group === 'verlengde') {
              if (!filter.checked) {
                  productsIds = [];
              }
          }
          if (filter.filtergroup === 'shapes') {
              let shapeBefore = Vue.ls.get('shapeBefore')
              if (shapeBefore !== null) {
                  if (shapeBefore === filter.value) {
                  } else { // if it is changed we have to delete the products in search
                      productsIds = [];
                  }
              } else { // if it is first time of shapes
                  productsIds = [];
              }

              Vue.ls.set("shapeBefore", filter.value)
              if (!this.filterIndex.includes(filter.filtergroup)) {
                  this.filterIndex.push(filter.filtergroup)
                  this.activeFilters.push(filter)
              } else {
                  //ml: if filter already set, adjust value
                  for (let j = 0; j < this.activeFilters.length; j++) {
                      //ml: search for filter with current group
                      if (this.activeFilters[j].filtergroup == filter.filtergroup) {
                          this.activeFilters[j].value = filter.value;
                          this.activeFilters[j].filterId = filter.filterId;
                      }
                  }
              }

              if (filter.value == 'Rechthoekig') {
                  this.filtersToHide = "hide[]=diameter";
              } else {
                  this.filtersToHide = "hide[]=widthandheight";
              }
          } else if(filter.filterId === "wandtype") {
              if (!this.filterIndex.includes(filter.filtergroup)) {
                  this.filterIndex.push(filter.filtergroup)
                  this.activeFilters.push(filter)
              } else {
                  for (let k = 0; k < this.activeFilters.length; k++) {
                      if (this.activeFilters[k].filtergroup === "wandtype") {
                          this.activeFilters[k].value = filter.value;
                      }
                  }
              }
          } else {
              if (!this.filterIndex.includes(filter.value)) {
                  this.filterIndex.push(filter.value)
                  this.activeFilters.push(filter)
              }
          }


          for (let j = 0; j < this.activeFilters.length; j++) {

              if (this.activeFilters[j].filtergroup === 'wandtype') {
                  if (this.activeFilters[j].filterId === "wandtype") {
                      wandtypeValue = this.activeFilters[j].value
                  }
/*                  if (this.activeFilters[j].filterId === "wandmaterialandthickness") {
                      materialThicknessValue = this.activeFilters[j].selects
                  }*/
              }

              if (this.activeFilters[j].filtergroup === "shapes") {
                  shapeValue = this.activeFilters[j].value
              }

              if(this.activeFilters[j].filterId === filter.filterId) {

                  if (filter.filterId !== undefined) {

                      if (shapeValue !== '') { //means there is a clicked shape
                          if (filter.filterId === 'width' || filter.filterId === 'height') { // if width and height setted
                              if (shapeValue === 'Rond') { // but is rounded form make no sense delete filter
                                  deleteArr.push(j)
                              }
                          }

                          if (filter.filterId === 'diameter') { // if diameter setted
                              if (shapeValue === 'Rechthoekig') { // but is cubic form make no sense delete filter
                                  deleteArr.push(j)
                              }
                          }
                      }
                  }
                  this.activeFilters[j] = filter
              }
          }

          for (let i in deleteArr) { // delete unnecesary filters with the shape logica
              this.activeFilters.splice(deleteArr[i], 1)
          }

          let paramsGetFilters = ''
          if (this.filtersToHide !== '') {
              paramsGetFilters = this.filtersToHide + '&wandtypevalue=' + wandtypeValue
          } else {
              paramsGetFilters = 'wandtypevalue=' + wandtypeValue
          }
          apiService.getFilters(paramsGetFilters, 'nl-be', this.setFilters)
          apiService.postFilters(this.activeFilters, productsIds, this.reset, 'nl-be', this.setProducts)
      },
      updateProducts(response) {
        this.products = response.data
      },
      getProductByName () {
        this.searching = true;
        this.searchMessage = this.$t('Even geduld... uw zoekopdracht wordt verwerkt');

        this.products = [];
        //this.activeFilters = [];
        //EventBus.$emit('filtersReset');
        if (this.searchQuery === "") {
          this.getAllProducts()
        } else {
            //this.filters = [];
            this.getFilters()
          apiService.getProductsByName(this.searchQuery, 'nl-be', this.setProducts)
        }
      },
      setSelected(product) {
        Vue.ls.set('StepOne', product)
        this.selected = product
        Vue.ls.remove('StepTwo')
        Vue.ls.remove('StepThree')

      },

      nextStep(bool) {
        if(bool) {
          this.warning = ''
        } else {
          this.warning = this.$t('Please select a product to continue');
        }
      },
      getFilteredProducts() {
        apiService.getFilteredProducts(this.filters, this.setFilteredProducts)
      },
      setFilteredProducts(products) {
        //console.log(products)
      },
      emptyProducts(response) {
      },
      setProducts(response) {
        this.currentFilterValues = []
        if (typeof response['filterValuesNoProducts'] !== 'undefined') { //means not product found
            this.currentFilterValues.push(response['filterValuesNoProducts'])
            this.searching = false
            this.products = []
            Vue.ls.remove('variantsIds')
            return false
        }
        let minimalBrandweerstand = ''
        //current active filters brandweerstand
        for (let j = 0; j < this.activeFilters.length; j++) {
            if (this.activeFilters[j].filterId === 'minimalebrandweer') {
                if (typeof this.activeFilters[j].selects !== 'undefined') {
                    minimalBrandweerstand = this.activeFilters[j].selects
                }

            }
        }

        let variantsIds = []
        this.currentFilterValues = []
        //special case voor SC
        let minimalBrandweerstandNum = minimalBrandweerstand.match(/\d/g);
        if (minimalBrandweerstandNum !== null) {
          minimalBrandweerstandNum = parseInt(minimalBrandweerstandNum.join(""));
        }
        /*minimalBrandweerstandNum = minimalBrandweerstandNum.join("");*/
        let newResponse = response
        this.deleteVariantArr = []
        for ( let x in newResponse ) {
            //special case voor SC
            let skipVariant = false
            let variantTitle = newResponse[x]._source.title

          if (!skipVariant) {
              let product = newResponse[x];
              if (x == 0 && product) {
                  if (typeof product['articles'][0] !== 'undefined') {
                      if (typeof product['articles'][0]['currentValues'] !== 'undefined') {
                          this.currentFilterValues.push(product['articles'][0]['currentValues'])
                      }
                  }
              }
              variantsIds.push(product._source.id);
          } else {
                console.log(newResponse)
          }

        }
        Vue.ls.set('variantsIds', variantsIds)
        //console.log(deleteVariantArr)
        //console.log(response)
        this.products = response
/*        if (this.products.length === 0) {
            Vue.ls.remove('variantsIds')
        }*/
        //console.log(this.products)
        this.searching = false
        if (this.searchViaProductId) {
          // Set timeout of 0 seconds is needed to open the dimensions. https://stackoverflow.com/a/779785
          setTimeout(() => {
            EventBus.$emit('openDimensions');
          }, 0)
        }
      },
      getImage(image) {
        //let imgUrl = "https://www.rft.be/derived" + image;
        return imgUrl
      },
      setModalFilters(response) {
        this.allFiltersModal = response;
      },
      deleteEverything () {
        let result = confirm(this.$t("Bent u zeker dat u wilt alles verwijderen?"));
        if (result == true) {
          Vue.ls.clear()
          location.reload()
          }
        },
/*      getModalFilters() {
        apiService.getFilters('modal=1', 'nl-be', this.setModalFilters)
      },*/
    },
    computed: {
      processedProducts: function () {

        let vm = this;
        let deletearr = this.deleteVariantArr
        //console.log('delete r')
        //console.log(deletearr)
        return this.products.map(function (product, x) {
            //console.log(product._source.title + 'index ' + x)
            if (deletearr.length > 0 && deletearr.indexOf(x.toString()) > -1) {
                //console.log('index a borrar' + x)
                    return {
                        id: product._source.id,
                        recommended: false,
                        erpCode: product._source.erpCode,
                        title: '',
                        description: '',
                        image: '',
                        specifications: '',
                        articles: [],
                        linkToWebsite: ''
                    }

            } else {
                if (product !== null) {
                   let specifications = []
                   if (product._source.voordelen) {
                     specifications = product._source.voordelen[vm.$i18n.locale]
                   }

                    return {
                        id: product._source.id,
                        recommended: product._source.recommended,
                        erpCode: product._source.erpCode,
                        title: product._source.title,
                        description: product._source.description[vm.$i18n.locale],
                        image: product._source.image,
                        specifications: specifications,
                        articles: product.articles,
                        linkToWebsite: product._source.linkToWebsite
                    }
                }
            }
            if (product !== null) {
                return {
                    id: product._source.id,
                    recommended: product._source.recommended,
                    erpCode: product._source.erpCode,
                    title: product._source.title,
                    description: product._source.description[vm.$i18n.locale],
                    image: product._source.image,
                    specifications: product._source.voordelen[vm.$i18n.locale],
                    articles: product.articles,
                    linkToWebsite: product._source.linkToWebsite
                }
            }

        })
      }
    },
    mounted: function() {
        //console.log('giro')
        if (Vue.ls.get('StepOne') !== null) {
            this.selected = Vue.ls.get('StepOne')
        }
      if (this.$route.query.newproductsamemec !== undefined) {
        this.newMec = '/steptwo/?newproduct=1'
          Vue.ls.set("newConf", true)
      } else if (this.$route.query.samemec) {
          Vue.ls.set("newConf", true)
          this.$router.push({name: 'StepThree'})
      } else if (this.$route.query.sameproductnewmeasures) {
        Vue.ls.set("newConf", true)
        this.$router.push({name: 'StepOne', params: {'productId' : this.$route.query.productId}})
      } else {
          Vue.ls.set("newConf", false)
      }

      EventBus.$emit('routeChange')
      this.getFilters()
      EventBus.$on('setFilter', this.postFilters)
      EventBus.$on('selected', this.setSelected)

      if (this.$route.params.productId) {
        this.searchViaProductId = true
        this.getProductsById(this.$route.params.productId)
      } else {
        this.searchViaProductId = false
        this.getAllProducts()
      }

      //this.getModalFilters()
      Vue.ls.remove('shapeBefore')
      Vue.ls.remove('variantsIds')
    },
    beforeDestroy() {
      EventBus.$off('filtersReset');
      EventBus.$off('newPostFilter');
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/StepOne.vue